export default {
  mounted(el: HTMLElement) {
    el.focus();
  },
};
